/* eslint-disable */
import * as React from 'react';
import PropTypes from 'prop-types';

const IconInstitutionZKI = ({
                              height = '32',
                              width = '32',
                              className = '',
                            }) => (
  <svg className={className} width={width} height={height} viewBox="0 0 240 240" xmlns="http://www.w3.org/2000/svg">
    <text x="120" y="140" fontFamily="Arial" fontSize="120" fontWeight="bold" fill="#000" textAnchor="middle"
          dominantBaseline="central">ZKI
    </text>
  </svg>
);

IconInstitutionZKI.propTypes = {
  strokeWidth: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
  className: PropTypes.string,
};

export default IconInstitutionZKI;
